import { Component, inject, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

import { TransaccionService } from 'src/app/modules/movimientos/movimientos.service';
import { CurrencyPipe, DatePipe, JsonPipe, Location, NgFor } from '@angular/common';
import { EstadoTransaccion, TipoPago, TipoTransaccion } from 'src/app/core/enum/global.enum';
import { MenuService } from 'src/app/modules/layout/services/menu.service';
import { ParametroService } from 'src/app/core/services/parametro.service';
import { FormasPagoService } from '../../formas-pago.service';
import { NotificacionPlaceToPay } from 'src/app/core/models/global.model';
import { catchError, Subscription, throwError } from 'rxjs';
import { ToastService } from 'src/app/core/services/toast-service.service';
import { GuardService } from 'src/app/core/services/guards.service';
import { DetalleTransaccionService } from 'src/app/core/services/detalleTransaccion.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { SkeletonModule } from 'primeng/skeleton';
import { RECARGA_AUTOMATICA_LINK_PENDING_KEY } from '../../formas-pago.service';

@Component({
  selector: 'app-modal-detalles-transaccion',
  standalone: true,
  imports: [DialogModule, DatePipe, CurrencyPipe, SkeletonModule, NgFor],
  providers: [ToastService],
  templateUrl: './modal-detalles-transaccion.component.html',
})
export class ModalDetallesTransaccionComponent implements OnInit {
  detalleTransaccionService = inject(DetalleTransaccionService);
  transaccionService = inject(TransaccionService);
  formasPagoService = inject(FormasPagoService);
  parametroService = inject(ParametroService);
  loadingService = inject(LoadingService);
  guardService = inject(GuardService);
  toastService = inject(ToastService);
  menuService = inject(MenuService);

  estadoTransaccionIcon: string = '';
  estadoTransaccionColor: string = '';

  placeToPayData = {};
  ajusteData = {};
  pasoData = {};

  lifeTimeMessages: number = 20000;
  visibleConfirmacionCompra: boolean = false;

  constructor(private location: Location) {}

  ngOnInit(): void {
    this.detalleTransaccionService.registerShowDialog(this.showDialog.bind(this));

    //console.log('Script PlacetoPay cargado...');
    P.on('response', (response: NotificacionPlaceToPay) => {
      this.formasPagoService
        .realizarNotificacion(response)
        .pipe(catchError(this.handleNotificationError.bind(this)))
        .subscribe(async (res: any) => {
          const { status, reason } = response.status;

          let toastConfig = {
            titulo: '',
            tipo: '',
            mensaje: res.data,
            life: this.lifeTimeMessages,
          };

          switch (status) {
            case 'REJECTED':
              if (sessionStorage.getItem(RECARGA_AUTOMATICA_LINK_PENDING_KEY) === '1')
                this.formasPagoService.paymentSetupResult$.next('link-error');
              toastConfig.titulo = reason === '?C' ? 'Atención' : 'Error';
              toastConfig.tipo = reason === '?C' ? 'info' : 'error';
              break;
            case 'PENDING':
              toastConfig.titulo = 'Advertencia';
              toastConfig.tipo = 'warn';
              break;
            default:
              await this.handleNotificationSuccess(res);
              break; // Salir del switch si no se necesita mostrar toast
          }
          // Verificar si toastConfig tiene contenido válido antes de mostrar el toast
          if (toastConfig.titulo && toastConfig.tipo) {
            this.toastService.showToast(toastConfig);
          }
          //this.showDetalleTransaccionDialog({tipoTransaccion: {id: 2}, codigoTransaccion: response.requestId.toString()});
          this.showDialog({ tipoTransaccion: { id: 2 }, codigoTransaccion: response.requestId.toString() });
        });
    });
    P.on('close', () => {
      //console.log('El usuario cerró el Lightbox');
      //
      this.loadingService.show();
    });
  }

  handleNotificationError({ error: { error } }: any) {
    if (sessionStorage.getItem(RECARGA_AUTOMATICA_LINK_PENDING_KEY) === '1')
      this.formasPagoService.paymentSetupResult$.next('link-error');
    this.loadingService.hide();
    const errorMessage = error || 'Unexpected error occurred';
    this.toastService.showToast({
      titulo: 'Error',
      tipo: 'error',
      mensaje: errorMessage,
      life: this.lifeTimeMessages,
    });
    return throwError(() => errorMessage);
  }

  async handleNotificationSuccess(res: any) {
    const { data } = res;
    this.guardService.setUserData(data, data?.usuarioFront);
    if (sessionStorage.getItem(RECARGA_AUTOMATICA_LINK_PENDING_KEY) === '1') {
      this.guardService.usuarioData().tipoPago = data?.tipoPago ?? {
        id: TipoPago.RECARGA_AUTOMATICA,
        nombre: 'Recarga automática',
      };
      this.formasPagoService.formaPagoSeleccionada = 'recargaautomatica';
      this.formasPagoService.paymentSetupResult$.next('link-success');
    }
    this.formasPagoService.executeFunction();
    if (['pasaypaga', 'recargaautomatica'].includes(this.formasPagoService.formaPagoSeleccionada)) {
      /* const { id } = this.guardService.usuarioData().cuenta; */
      /* this.formasPagoService
        .cambiarTipoPago(id, { tipoPago: TipoPago.PASA_PAGA_Y_TOLIS })
        .pipe(catchError(this.handleChangeError.bind(this)))
        .subscribe((res) => {
          this.handleChangeSuccess(res);
        }); */
      this.formasPagoService.getMedioPagoByCuentaId();
    }
    this.toastService.showToast({
      titulo: 'Transacción realizada exitosamente',
      tipo: 'success',
      mensaje: 'La transacción realizada con PlacetoPay ha finalizado satisfactoriamente.',
      life: this.lifeTimeMessages,
    });
    //
    const path = this.location.path();
    if (path.includes('dashboard') || path.includes('formas-pago')) {
      this.transaccionService.getListadoTransaccionesMongo(EstadoTransaccion.PENDING, 1);
      this.transaccionService.getListadoTransacciones({ limit: 5, page: 1 });
    }
  }

  handleChangeSuccess(res: any) {
    const { tipoPago, saldo } = res.data;
    this.guardService.usuarioData().tipoPago = tipoPago;
    if (saldo < 0) {
      this.guardService.usuarioData().cuenta.saldo = 0;
    }
    this.formasPagoService.executeFunction();
    this.toastService.showToast({
      titulo: 'Cambio realizado exitosamente',
      tipo: 'success',
      mensaje: 'Se ha cambiado el tipo de pago satisfactoriamente.',
      life: this.lifeTimeMessages,
    });
  }

  handleChangeError({ error: { error } }: any) {
    const errorMessage = error || 'Unexpected error occurred';
    this.toastService.showToast({
      titulo: 'Error',
      tipo: 'error',
      mensaje: errorMessage,
      life: this.lifeTimeMessages,
    });
    return throwError(() => errorMessage);
  }

  showDialog({ codigoTransaccion, tipoTransaccion }: any) {
    this.loadingService.hide();
    // Mostrar el modal de detalle de transacción
    this.menuService.modalDetalleTransaccionVisible = true;

    // Limpiar datos de transacción y obtener parámetros
    this.transaccionService.clearDataTransaccion();
    this.parametroService.getParametros();

    const actionsMap: { [key in TipoTransaccion]?: () => Subscription } = {
      [TipoTransaccion.PASO]: () => this.transaccionService.getPasoByCodigoPaso(codigoTransaccion),
      [TipoTransaccion.RECARGA]: () => this.transaccionService.getPasoByRequestId(codigoTransaccion),
      [TipoTransaccion.AJUSTE_DEBITO]: () => this.transaccionService.getAjusteByCodigoAjuste(codigoTransaccion),
      [TipoTransaccion.AJUSTE_CREDITO]: () => this.transaccionService.getAjusteByCodigoAjuste(codigoTransaccion),
      [TipoTransaccion.PASO_SUSCRIPCION]: () => this.transaccionService.getPasaPagaByCodigoPaso(codigoTransaccion),
      [TipoTransaccion.PAGO_POR_SUSCRIPCION]: () => this.transaccionService.getPasoByRequestId(codigoTransaccion),
      [TipoTransaccion.PAGO_MIXTO]: () => this.transaccionService.getPasoByCodigoPaso(codigoTransaccion),
      [TipoTransaccion.REGISTRO_MEDIO_PAGO]: () => this.transaccionService.getPasoByRequestId(codigoTransaccion),
      [TipoTransaccion.CAMBIO_FORMA_PAGO]: () => this.transaccionService.getPasoByRequestId(codigoTransaccion),
      [TipoTransaccion.COMPRA]: () => this.transaccionService.getPasoByRequestId(codigoTransaccion),
      [TipoTransaccion.NOTA_DEBITO_MANUAL]: () =>
        this.transaccionService.getNotaCreditoByCodigoTransaccion(codigoTransaccion),
      [TipoTransaccion.NOTA_CREDITO_MANUAL]: () =>
        this.transaccionService.getNotaCreditoByCodigoTransaccion(codigoTransaccion),
    };
    const id = tipoTransaccion?.id as TipoTransaccion;
    // Ejecutar la acción correspondiente si existe
    const action = actionsMap[id];
    if (action) {
      action();
    } else {
      console.warn('Tipo de transacción no manejado:', id);
    }
  }

  motivosAjustes(tipoMotivo: string) {
    const motivo: { [key: string]: any } = {
      '1': 'Cambio de categoría',
      '2': 'Cancelación',
      '3': 'Cambio de Tarifa',
    };
    return motivo[tipoMotivo] || 'Tipo de motivo desconocida.';
  }

  estadosTransaccion(estado: string) {
    const opcionesEstado: { [key: string]: any } = {
      APPROVED: 'Transacción aprobada',
      REJECTED: 'Transacción rechazada',
      PENDING: 'Transacción pendiente',
      APPROVED_PARTIAL: 'Transacción aprobada parcial',
      PARTIAL_EXPIRED: 'Transacción parcial expirada',
    };
    return opcionesEstado[estado] || 'Estado de transacción desconocido.';
  }

  estadosTransaccionIcon(estado: string) {
    const opcionesEstado: { [key: string]: any } = {
      APPROVED: (this.estadoTransaccionIcon = 'pi pi-check-circle'),
      REJECTED: (this.estadoTransaccionIcon = 'pi pi-times-circle'),
      PENDING: (this.estadoTransaccionIcon = 'pi pi-exclamation-circle'),
      APPROVED_PARTIAL: (this.estadoTransaccionIcon = 'pi pi-verified'),
      PARTIAL_EXPIRED: (this.estadoTransaccionIcon = 'pi pi-question-circle'),
    };
    return opcionesEstado[estado] || 'Estado de transacción desconocido.';
  }

  estadosTransaccionColor(estado: string) {
    const opcionesEstado: { [key: string]: any } = {
      APPROVED: (this.estadoTransaccionColor = 'color: #16a34a;'),
      REJECTED: (this.estadoTransaccionColor = 'color: red;'),
      PENDING: (this.estadoTransaccionColor = 'color: #ea580c;'),
      APPROVED_PARTIAL: (this.estadoTransaccionColor = 'color: #16a34a;'),
      PARTIAL_EXPIRED: (this.estadoTransaccionColor = 'color: red'),
    };
    return opcionesEstado[estado] || 'Estado de transacción desconocido.';
  }

  getValueByKeyWord(array: Array<any>) {
    const result =
      array.find((item) => item.keyword === 'lastDigits') || array.find((item) => item.keyword === 'terminalNumber');

    return result ? result.value : '-';
  }

  closeDialog() {
    this.menuService.modalDetalleTransaccionVisible = false;
    // Mostrar confirmación de compra de tag solo si está en vehiculo/gestion
    const currentPath = this.location.path();
    const transactionStatus = this.transaccionService.statePlaceToPayData()?.data?.status?.status;
    if (currentPath.includes('vehiculo/gestion') && transactionStatus === 'APPROVED') {
      this.visibleConfirmacionCompra = true;
    }
  }
}
